export default __webpack_public_path__ + "static/media/CBQ-sample.693c1fd5.xlsx";